<template>
    <v-layout class="mt-3">
        <v-flex xs12>
            <v-card class="mx-auto pa-2 elevation-0">
                <v-layout>
                    <v-flex xs12 md4>
                        <v-list two-line class="pa-0">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title
                                        v-html="$vuetify.lang.t('$vuetify.next_destination_country')"></v-list-item-title>
                                    <v-list-item-subtitle
                                        v-html="visa.extra.application_data.next_destination_country"></v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-list two-line class="pa-0">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title
                                        v-html="$vuetify.lang.t('$vuetify.next_flight_number')"></v-list-item-title>
                                    <v-list-item-subtitle
                                        v-html="visa.extra.application_data.next_flight_number"></v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>

    export default {
        computed: {
            visa() {
                return this.$store.state.VisaSingle.visa;
            }
        },

    };
</script>

<style>
</style>
